/**
 * INCENTIVE-TRACKER MODULE
 * Self-contained. Import only from /shared or within this module.
 */
import { useNavigate, useParams } from "react-router-dom";
import ProgramDetailPage from "../components/ProgramDetailPage.jsx";

// Single program: draft editor, review, scoring, and export — the view shown
// adapts to the program's status (the one object moving through its lifecycle).
export default function IncentiveProgram() {
  const navigate = useNavigate();
  const { programId } = useParams();
  return (
    <ProgramDetailPage
      programId={programId}
      onBack={() => navigate("/incentives")}
      onHome={() => navigate("/")}
      onDistributorProgress={(d) => navigate(`/incentives/progress/${encodeURIComponent(d)}`)}
    />
  );
}
